import { service } from '../utils/request';

export function getOrders(params) {
    return service({
        url: '/orders?pageSize=' + params.pageSize + '&page=' + params.page + '&sort=-uid',
        method: 'get'
    });
}

export function deleteOrder(id, data) {
    return service({
        url: '/orders/order/complete/' + id,
        method: 'post',
        data
    });
}